/* eslint-disable react/prop-types */
import React from 'react'

const PhoneLink = (phoneNumber) => <a href={`tel:${phoneNumber}`}>{phoneNumber}</a>

export default PhoneLink
